import React from "react";
import { Modal, Button } from "react-bootstrap";
import { deleteCheque } from "../../../Api/ChequesApi";

const ChequeDeleteModal = ({ show, onHide, cheque, onDeleted }) => {
  // ⛔ PRIMERO validar existencia
  if (!show || !cheque) return null;

  // ⛔ DESPUÉS validar estado
  if (cheque.estado !== "CREADO") return null;

  const eliminar = async () => {
    await deleteCheque(cheque.idcheque);
    onDeleted();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar Cheque</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        ¿Eliminar el cheque de <b>{cheque.nombre}</b>?
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={eliminar}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChequeDeleteModal;
